import React, { useEffect } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { useParams, useHistory, withRouter } from 'react-router-dom';
import { getNetworkTextForValue } from 'AppSrc/core/crq/crq-table-utils';
import { LoadingSpinner } from 'AppSrc/core/components/utility/loading-spinner';
import { fetchCrqForViewEdit } from 'AppSrc/core/actions/actions-edit-form';
import { setErrorAlert } from 'AppSrc/core/actions/actions-error-alert';
import { DevRemedyIdControls } from 'AppSrc/core/components/header/dev-user-role-controls';
import { getViewCrqPowers } from 'AppSrc/core/components/view-crq-screen/utility-functions/get-view-crq-powers';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  VIEWING_CRQ,
  ES_VIEWING_NEW_SECTION,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import {
  getEditingStatus,
} from 'AppSrc/core/components/forms/form-section-utility-functions';
import { getIsInternationalCrq } from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { ViewCrqScreenContent } from './view-crq-screen-content';
import 'AppSrc/core/style/components/view-crq-screen/view-crq-screen.css';
import { BackAndRefresh } from '../utility/back-refresh';


// FN: 20/05/2020
// At the time of writing this there was nothing that would ever change the editingStatus for this view
const editingStatus = getEditingStatus({
  isNavEditing: false,
  isSummaryEditing: false,
  flow: VIEWING_CRQ,
});

console.log('dummy', editingStatus);
const formDataFromServerShape = PropTypes.shape({
  formSectionsByDisplayOrder: PropTypes.array,
  dataByFormSectionId: PropTypes.object,
  status: PropTypes.string,
  coordinatorName: PropTypes.string,
  peerReviewerName: PropTypes.string,
  requesterName: PropTypes.string,
  postpone_reason1: PropTypes.string,
  postpone_reason2: PropTypes.string,
  postpone_reason3: PropTypes.string,
});




const ViewCrqScreenDisplayUnconnected = ({
  crqId,
  network,
  fetching,
  formData,
  userRoles,
  remedyId,
  history,
  summarySectionsRead,
  viewCrqPowers,
  approvalsContext,
}) => {
  let networkText = getNetworkTextForValue(network);
  // const isOloCrq = getIsOlaCrq(formData);
  // if (isOloService) {
  //   networkText = 'Fixed';
  // }
  // const OLOCrq = isOloService ? ' OLO' : '';
  const changeDetails = 'CHANGE_DETAILS';
  const oloFlagNetwork = formData ? formData.dataByFormSectionId[changeDetails].dataByFieldId.services.value : null;
  const isRelevantOloService = (oloFlagNetwork === 'Network: Other Licensed Operator (OLO)' || oloFlagNetwork === 'Network: International Other Licensed Operator (OLO)') ? true : false;
  if (isRelevantOloService) {
    networkText = 'Fixed';
  }
  const OLOCrq = isRelevantOloService ? ' OLO' : '';
  const isIcmCrq = getIsInternationalCrq(formData);
  if (isIcmCrq) {
    networkText = 'Fixed';
  }
  const ICMCRQ = isIcmCrq ? ' International' : '';
  const showLoader = fetching;
  // const networkText = getNetworkTextForValue(network);
  // const showLoader = fetching;
  const circuitCheckAssignID = formData && formData.assignToMeFlag;

  return (
    <div className="page-content-container view-crq-screen">
      <div className="page-top">
        <h1 className="page-title">{`${crqId} (${networkText + ICMCRQ + OLOCrq})`}</h1>
        <BackAndRefresh />
      </div>
      <div className="page-content">
        <div className="page-content-inner">
          {
            showLoader && (
              <div className="view-crq-loader">
                <LoadingSpinner />
              </div>
            )
          }
          {
            formData ? (
              <ViewCrqScreenContent
                crqId={crqId}
                network={network}
                formData={formData}
                userRoles={userRoles}
                remedyId={remedyId}
                history={history}
                summarySectionsRead={summarySectionsRead}
                viewCrqPowers={viewCrqPowers}
                fetching={fetching}
                approvalsContext={approvalsContext}
                changeAnalystCircuitCheckID={circuitCheckAssignID && circuitCheckAssignID}
              />
            ) : null
          }
        </div>
      </div>
    </div>
  );
};

ViewCrqScreenDisplayUnconnected.propTypes = {
  network: PropTypes.string,
  crqId: PropTypes.string,
  fetching: PropTypes.bool,
  userRoles: PropTypes.objectOf(PropTypes.string),
  remedyId: PropTypes.string,
  formData: formDataFromServerShape,
  history: ReactRouterPropTypes.history,
  summarySectionsRead: PropTypes.objectOf(PropTypes.bool),
  viewCrqPowers: PropTypes.objectOf(PropTypes.bool),
  approvalsContext: PropTypes.bool,
};



const ViewCrqScreenUnconnected = ({
  userRoles,
  remedyIds,
  fetchCrq,
  errorAlert,
  formData,
  summarySectionsRead,
  fetching,
  isChangeAnalyst, // mapping changeAnalyst to the props of ViewCrqScreenUnconnected method
}) => {
  const { crqId, network, context } = useParams();
  const history = useHistory();
  // load up crq data on mount
  useEffect(() => {
    fetchCrq({
      network,
      crqId,
    }).catch((error) => {
      console.error(error);
      // redirect to the page not found screen
      errorAlert({
        errorTitle: 'Failed to load CRQ',
        errorText: 'Unable to load CRQ data. Please refresh the page and try again.',
      });
    });
  }, [crqId, network, userRoles, remedyIds, fetchCrq, errorAlert, history]);


  const remedyId = remedyIds[network];
  const viewCrqPowers = formData ? getViewCrqPowers({
    userRoles, remedyId, formData, isChangeAnalyst,
  }) : {}; // Sending isChangeAnalyst as an extra field to the getViewCrqPowers
  const approvalsContext = context === 'approvals';
  return (
    <>
      <DevRemedyIdControls
        network={network}
        formData={formData}
      />
      <ViewCrqScreenDisplay
        network={network}
        userRoles={userRoles}
        remedyId={remedyId}
        crqId={crqId}
        fetching={fetching}
        formData={formData}
        history={history}
        summarySectionsRead={summarySectionsRead}
        viewCrqPowers={viewCrqPowers}
        approvalsContext={approvalsContext}
      />
    </>
  );
};

ViewCrqScreenUnconnected.propTypes = {
  remedyIds: PropTypes.objectOf(PropTypes.string),
  userRoles: PropTypes.objectOf(PropTypes.string),
  fetchCrq: PropTypes.func,
  errorAlert: PropTypes.func,
  formData: formDataFromServerShape,
  summarySectionsRead: PropTypes.objectOf(PropTypes.bool),
  fetching: PropTypes.bool,
  isChangeAnalyst: PropTypes.bool, // changeAnalyst PropTypes validation
};

const mapStateToProps = (state, ownProps) => {
  const crqId = ownProps.match.params.crqId;
  const formData = state.editForm.formDataById[crqId];
  const summarySectionsRead = (formData && formData.summarySectionsRead) ? formData.summarySectionsRead : {};
  const fetching = state.editForm.fetchingById[crqId] ? true : false;
  const isChangeAnalyst = state && state.auth.isChangeAnalyst; // Fetching if the user is changeAnalyst or not

  return ({
    remedyIds: state.auth.user.remedyIds,
    userRoles: state.auth.user.roles,
    formData,
    summarySectionsRead,
    fetching,
    isChangeAnalyst,
  });
};


const mapDispatchToProps = (dispatch, ownProps) => ({
  // as this is dispatch from an asynch request, we need to return it to catch any errors
  fetchCrq: ({
    crqId,
    network,
  }) => dispatch(fetchCrqForViewEdit({
    crqId,
    network,
    editingStatus: ES_VIEWING_NEW_SECTION,
    shouldFetchRemRef: true,
  })),
  errorAlert: (alertData) => {
    dispatch(setErrorAlert(alertData));
  },
});




const ViewCrqScreen = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewCrqScreenUnconnected));

const ViewCrqScreenDisplay = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewCrqScreenDisplayUnconnected));

export {
  ViewCrqScreen,
  ViewCrqScreenDisplay,
};
